import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, inject } from "@angular/core";
import { Router } from "@angular/router";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Subject, of, switchMap, takeUntil } from "rxjs";

// MODELS
import { GlobalVarsModel } from "@models/ModelGlobalsVar";

import { NewBaseService } from "@providers/newBase.service";
// SERVICES
import { DeviceService } from "@services/device.service";

// STORES
import { NewTicketFacade } from "@sports-features/ticket/stores";
import { BuModalComponent } from "./bu-modal/bu-modal.component";

@Component({
  selector: "betslip-unlocker-page",
  templateUrl: "betslip-unlocker.page.html",
  styleUrls: ["betslip-unlocker.page.scss"],
  host: {
    class: "betslip-unlocker",
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
})
export class BetslipUnlockerPage implements OnDestroy {
  globalVars: GlobalVarsModel;
  router = inject(Router);
  deviceService = inject(DeviceService);
  newBaseService = inject(NewBaseService);
  isMobile: boolean = false;

  ticketFacade = inject(NewTicketFacade);
  translate = inject(TranslateService);
  modalCtrl = inject(ModalController);

  private readonly unsubscribe$ = new Subject();

  constructor() {
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          this.globalVars.showNavbar = false;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  clearAll() {
    this.showRestartTicketAlert();
  }

  private async showRestartTicketAlert() {
    const modalConfirm = await this.modalCtrl.create({
      component: BuModalComponent,
      componentProps: {
        title: this.translate.instant("Attention"),
      },
      cssClass: "cs-request-info",
    });
    await modalConfirm.present();
    const { data } = await modalConfirm.onWillDismiss();
    if (data) {
      this.ticketFacade.restartBetslip();
      this.globalVars.showNavbar = true;
      this.router.navigate(["/HomePage"]);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
